export default "__VITE_ASSET__CMoqw$Bc__"